export default __webpack_public_path__ + "static/media/barcode.b04ec60d.svg";